import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink, Navigate } from 'react-router-dom';
import { t } from '@/core/localization';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, getLinkTo, title, groups } = appSections.crossdockingReceipt;
export const crossdockReceiptRoutes = [
    {
        // TODO: check if this navigate is working
        path: rootPath,
        element: _jsx(Navigate, { to: "invoices", replace: true }),
    },
    {
        path: rootPath,
        lazy: async () => {
            const { CrossdockingReceiptContainer } = await import('@/warehouse/modules/crossdockReceipt');
            return {
                element: (_jsx(ProtectedRoute, { groups: groups, children: _jsx(CrossdockingReceiptContainer, {}) })),
            };
        },
        handle: {
            crumb: ({ params: { crossDockId } }) => _jsx(NavLink, { to: getLinkTo(crossDockId), children: title }),
        },
        children: [
            {
                path: ':tab',
                lazy: async () => {
                    const { CrossdockingReceipt } = await import('@/warehouse/modules/crossdockReceipt');
                    return { Component: CrossdockingReceipt };
                },
                handle: {
                    crumb: ({ params: { crossDockId, tab } }) => (_jsx(NavLink, { to: `${getLinkTo(crossDockId)}/${tab}`, children: tab === 'invoices' ? t('incoming.label') : tab === 'verification' ? t('verification.label') : 'UNKNOWN' })),
                },
            },
            {
                path: ':tab/:invoiceId',
                lazy: async () => {
                    const { Invoice } = await import('@/warehouse/modules/crossdockReceipt/components/Invoice');
                    return { Component: Invoice };
                },
                handle: {
                    crumb: ({ params: { crossDockId, tab } }) => (_jsx(NavLink, { to: `${getLinkTo(crossDockId)}/${tab}`, relative: "path", children: t('incoming.label') })),
                },
            },
        ],
    },
];
